module.exports = __webpack_public_path__ + "static/media/AppliedDiff_Q6.ca7d9dc1.svg";